export default {"src":"/_next/static/media/logo-nhncrossent.73632c8f.svg","height":120,"width":292,"blurWidth":0,"blurHeight":0};